module.exports = __webpack_public_path__ + "img/pvc-half.33401ba.svg";